import type {CompetenceLevel} from "./activity-library";

export type AutomaticAbsences = Record<string, {previous?: CompetenceLevel; previousAt?: string}>;

/** Legacy/direct session evaluation follows the same provenance rule as digital copies. */
export function sessionAttendance(keys: string[], absent: boolean, previous: {
  results: Record<string, CompetenceLevel>; dates?: Record<string, string>;
  evaluations?: Record<string, CompetenceLevel>; automatic?: AutomaticAbsences;
}, now: string) {
  const results = {...previous.results}, dates = {...previous.dates};
  const evaluations = {...previous.evaluations}, automatic = {...previous.automatic};
  for (const key of keys) {
    if (absent && !evaluations[key] && (!results[key] || (results[key] === "NE" && !dates[key]))) {
      automatic[key] = {previous: results[key], previousAt: dates[key]};
      results[key] = "ABS"; dates[key] = now; evaluations[key] = "ABS";
    } else if (!absent && automatic[key]) {
      if (results[key] === "ABS") {
        if (automatic[key].previous) results[key] = automatic[key].previous!; else delete results[key];
        if (automatic[key].previousAt) dates[key] = automatic[key].previousAt!; else delete dates[key];
      }
      delete evaluations[key]; delete automatic[key];
    }
  }
  return {results, dates, evaluations, automatic};
}
